import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PRICING_PLANS } from "../landingData";

/** Set to true to restore the original three-plan pricing cards. */
const SHOW_LEGACY_PRICING_CARDS = false;

const LandingPricing = () => {
  const { t } = useTranslation("common");

  return (
    <section className="pricing" id="pricing">
      <div className="section-header">
        <h2>{t("Simple Pricing")}</h2>
        <p>{t("Start free, scale as you grow")}</p>
      </div>

      {SHOW_LEGACY_PRICING_CARDS ? (
        <div className="pricing-grid">
          {PRICING_PLANS.map(
            ({
              nameKey,
              price,
              priceKey,
              priceSuffix,
              priceSuffixKey,
              descriptionKey,
              highlight,
              popular,
              featureKeys,
              ctaKey,
              ctaType
            }) => (
              <div key={nameKey} className={`pricing-card ${highlight ? "highlight" : ""}`}>
                {popular ? <div className="popular-badge">{t("POPULAR")}</div> : null}
                <div className="plan-name">{t(nameKey)}</div>
                <div className="plan-price">
                  {priceKey ? t(priceKey) : price}
                  {priceSuffixKey ? <span>{t(priceSuffixKey)}</span> : null}
                  {priceSuffix ? <span>{priceSuffix}</span> : null}
                </div>
                <div className="plan-desc">{t(descriptionKey)}</div>
                <ul className="plan-features">
                  {featureKeys.map((featureKey) => (
                    <li key={featureKey}>
                      <span className="check">✓</span> {t(featureKey)}
                    </li>
                  ))}
                </ul>
                {ctaType === "button" ? (
                  <button type="button" className="btn-plan">
                    {t(ctaKey)}
                  </button>
                ) : (
                  <Link
                    to="/login"
                    className={`btn-plan ${highlight ? "highlight-btn" : ""}`}>
                    {t(ctaKey)}
                  </Link>
                )}
              </div>
            )
          )}
        </div>
      ) : (
        <div className="pricing-offer">
          <h3 className="pricing-offer-title">
            {t("Annual Subscription – Just $1 + 5 Free Tokens!")}
          </h3>
          <p className="pricing-offer-desc">
            {t("Subscribe for $1 and get 5 free tokens. Buy additional tokens whenever you need them.")}
          </p>
          <Link to="/login?view=register" className="btn-primary pricing-offer-cta">
            {t("Subscribe Now")}
          </Link>
        </div>
      )}
    </section>
  );
};

export default LandingPricing;
